import React, { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns } from '../../../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../../Interface';
import conformityService from '../../../../service/client/varadiMetal/conformity.service';
import dayjs from 'dayjs';

const ConformityReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autocompleteOptions,
  autocompleteData,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'id', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    conformityService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'id',
        headerName: '#',
        type: 'string',
        filterable: false,
      },
      {
        field: 'companyId',
        headerName: 'Cég',
        type: 'singleSelect',
        sortable: false,
        renderCell: (data) => {
          return data.row.company?.name;
        },
        valueOptions: autocompleteOptions.company,
      },
      {
        field: 'itemCode',
        headerName: 'Cikkszám',
        type: 'singleSelect',
        sortable: false,
        renderCell: (data) => {
          return data.row.item?.itemCode;
        },
        valueOptions: autocompleteOptions.items,
      },
      {
        field: 'itemName',
        headerName: 'Cikk megnevezés',
        type: 'string',
      },
      {
        field: 'itemDescription',
        headerName: 'Cikk megjegyzés',
        type: 'string',
      },
      {
        field: 'baseDocnum',
        headerName: 'Bizonylat szám',
        type: 'string',
      },
      {
        field: 'standard',
        headerName: 'Szabvány',
        type: 'string',
      },
      {
        field: 'orderNo',
        headerName: 'Rendelési szám',
        type: 'string',
      },
      {
        field: 'deliveryNo',
        headerName: 'Szállítólevél szám',
        type: 'string',
      },
      {
        field: 'deliveryDate',
        headerName: 'Szállítás dátuma',
        type: 'date',
        valueGetter: (value) => (value ? new Date(value) : null),
        valueFormatter: (value) => (value ? dayjs(value).format('YYYY.MM.DD.') : ''),
      },
      {
        field: 'certificateNo',
        headerName: 'Jegyzőkönyvek',
        type: 'string',
      },
      {
        field: 'measureDate',
        headerName: 'Mérés dátuma',
        type: 'date',
        valueGetter: (value) => (value ? new Date(value) : null),
        valueFormatter: (value) => (value ? dayjs(value).format('YYYY.MM.DD.') : ''),
      },
      {
        field: 'classification',
        headerName: 'Osztályozás',
        type: 'string',
      },
      {
        field: 'comment',
        headerName: 'Megjegyzés',
        type: 'string',
      },
      {
        field: 'issueDate',
        headerName: 'Kiadás dátuma',
        type: 'date',
        valueGetter: (value) => (value ? new Date(value) : null),
        valueFormatter: (value) => (value ? dayjs(value).format('YYYY.MM.DD.') : ''),
      },
    ]);
  }, [autocompleteOptions]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.Conformity}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default ConformityReports;
